export const Spanish = {
  Features: "Características",
  Blog: "Blog",
  Trade: "Comercio",
  trade: "comercio",
  Buy: "Comprar/Vender",
  Download: "Descargar",
  The: "El/La",
  gateway: "puerta de enlace",
  to: "a",
  To: "A",
  the: "el/la",
  next: "próxima",
  generation: "generación",
  of: "de",
  Gamers: "jugadores",
  Your: "Tu",
  games: "juegos",
  coins: "monedas",
  All: "Todo",
  in: "en",
  one: "uno",
  place: "lugar",
  Simple: "Simple",
  fun: "divertido",
  and: "y",
  And: "Y",
  super: "super",
  smart: "inteligente",
  Scan: "Escanear",
  download: "descargar",
  app: "aplicación",
  Available: "Disponible",
  on: "en",
  assets: "activos",
  Assets: "Activos",
  Game: "Juego",
  game: "juego",
  Connect: "Conectar",
  thirdparty: "terceros",
  Crypto: "Cripto",
  Card: "Tarjeta",
  Authentication: "Autenticación",
  Own: "Propio",
  your: "tu",
  earn: "ganar",
  is: "es",
  Is: "Es",
  easy: "fácil",
  way: "manera",
  store: "almacenar",
  manage: "gestionar",
  winnings: "ganancias",
  Whether: "Ya sea",
  youre: "eres",
  Youre: "Eres",
  competitive: "competitivo",
  gamer: "jugador",
  or: "o",
  just: "solo",
  casual: "casual",
  player: "jugador",
  has: "tiene",
  something: "algo",
  for: "para",
  everyone: "todos",
  effortlessly: "sin esfuerzo",
  converts: "convierte",
  into: "en",
  preferred: "preferido",
  cryptocurrency: "criptomoneda",
  start: "comenzar",
  earning: "ganando",
  Exclusive: "Exclusivo",
  content: "contenido",
  experiences: "experiencias",
  now: "ahora",
  at: "en",
  fingertips: "puntas de los dedos",
  passport: "pasaporte",
  unlock: "desbloquear",
  favourite: "favorito",
  need: "necesitas",
  do: "hacer",
  connect: "conectar",
  any: "cualquier",
  other: "otro",
  Gaming: "Juego",
  Platform: "Plataforma",
  account: "cuenta",
  Once: "Una vez",
  connected: "conectado",
  youll: "estarás",
  Youll: "Estarás",
  be: "serás",
  able: "capaz",
  rewards: "recompensas",
  unlocking: "desbloqueo",
  instantly: "instantáneamente",
  enjoying: "disfrutando",
  powered: "alimentado",
  by: "por",
  will: "será",
  launch: "lanzar",
  token: "token",
  listing: "listado",
  major: "importante",
  coming: "próximo",
  soon: "pronto",
  participate: "participar",
  our: "nuestra",
  premium: "premium",
  collections: "colecciones",
  you: "tú",
  You: "Tú",
  must: "debes",
  signup: "registrarte",
  get: "obtener",
  verified: "verificado",
  buy: "comprar",
  using: "usando",
  respectively: "respectivamente",
  Smartest: "Más inteligente",
  Safe: "Seguro",
  Secure: "Seguro",
  Earn: "Ganar",
  Big: "Grande",
  Join: "Unirse",
  Trend: "Tendencia",
  Dont: "No",
  left: "dejado",
  behind: "atrás",
  Welcome: "Bienvenido",
  world: "mundo",
  possibilities: "posibilidades",
  space: "espacio",
  no: "no",
  longer: "más",
  thing: "cosa",
  it: "eso",
  present: "presente",
  Over: "Más de",
  invested: "invertido",
  projects: "proyectos",
  past: "pasado",
  year: "año",
  free: "gratis",
  easiest: "más fácil",
  anywhere: "en cualquier lugar",
  anytime: "en cualquier momento",
  Use: "Usar",
  accepted: "aceptado",
  from: "de",
  online: "en línea",
  globally: "a nivel mundial",
  With: "Con",
  an: "un",
  instant: "instantáneo",
  cash: "efectivo",
  conversions: "conversiones",
  can: "puede",
  spend: "gastar",
  without: "sin",
  hassles: "molestias",
  top: "superior",
  notch: "calidad",
  security: "seguridad",
  blockchain: "cadena de bloques",
  backbone: "columna vertebral",
  are: "son",
  always: "siempre",
  safe: "seguro",
  perfect: "perfecto",
  most: "la mayoría",
  out: "fuera",
  Rewarding: "recompensante",
  complete: "completo",
  control: "control",
  over: "sobre",
  funds: "fondos",
  while: "mientras",
  prioritizing: "priorizando",
  gaming: "juegos",
  back: "atrás",
  with: "con",
  every: "cada",
  use: "uso",
  today: "hoy",
  level: "nivel",
  up: "arriba",
  rules: "reglas",
  only: "solo",
  keys: "claves",
  so: "así que",
  Our: "Nuestro",
  audited: "auditado",
  audit: "auditoría",
  firms: "empresas",
  constantly: "constantemente",
  reviewed: "revisado",
  ensure: "asegurar",
  maximum: "máximo",
  Convenience: "Conveniencia",
  moment: "momento",
  WAYS: "FORMAS",
  AUTHENTICATION: "AUTENTICACIÓN",
  TO: "A",
  STRENGTHEN: "FORTALECER",
  YOUR: "TU",
  ASSETS: "ACTIVOS",
  SAFETY: "SEGURIDAD",
  enjoy: "disfrutar",
  all: "todo",
  this: "esto",
  amazing: "increíble",
  functionalities: "funcionalidades",
  A: "Un",
  Decentralized: "Descentralizado",
  wallet: "cartera",
  dedicated: "dedicado",
  Home: "Inicio",
  Marketplace: "Mercado",
  Privacy: "Privacidad",
  Policy: "Política",
  Terms: "Términos",
  Service: "Servicio",
  Navigation: "Navegación",
  Products: "Productos",
  Legal: "Legal",
  What: "Qué",
  How: "Cómo",
  blockchains: "cadenas de bloques",
  does: "hace",
  support: "apoyo",
  types: "tipos",
  deposit: "depósito",
  withdraw: "retirar",
  earned: "ganado",
  my: "Mi",
  I: "I",
};
